import noop from 'lodash-es/noop';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import utils from '../../../../common/utils';

const buildHyperlinkTarget = hyperlink =>
  hyperlink.substr(0, 1) === '#' || hyperlink.substr(0, 7) === 'mailto:'
    ? '_self'
    : '_blank';

const StandardBlockWrapper = styled.div`
  opacity: 1;
  background-color: transparent;
  mix-blend-mode: ${props =>
    props.globalCompositeOperation === 'source-over'
      ? 'normal'
      : props.globalCompositeOperation};
  filter: ${props =>
    props.shadow
      ? utils.getDropShadowCSSFilterFromFabricShadow(
          props.shadow,
          props.groupAngle,
          props.localScale,
        )
      : 'none'};
`;
StandardBlockWrapper.propTypes = {
  globalCompositeOperation: PropTypes.string.isRequired,
  shadow: PropTypes.objectOf(PropTypes.any),
  groupAngle: PropTypes.number.isRequired,
  localScale: PropTypes.number.isRequired,
};
StandardBlockWrapper.defaultProps = {
  shadow: null,
};

const LinkBlockWrapper = StandardBlockWrapper.withComponent('a');

const BlockWrapper = props =>
  props.hyperlink ? (
    <LinkBlockWrapper
      {...props}
      href={props.hyperlink}
      target={buildHyperlinkTarget(props.hyperlink)}
      onMouseDown={utils.preventDefault}
    />
  ) : (
    <StandardBlockWrapper {...props} />
  );
BlockWrapper.propTypes = {
  globalCompositeOperation: PropTypes.string.isRequired,
  shadow: PropTypes.objectOf(PropTypes.any),
  groupAngle: PropTypes.number,
  localScale: PropTypes.number,
  hyperlink: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};
BlockWrapper.defaultProps = {
  shadow: null,
  hyperlink: null,
  style: {},
  onMouseEnter: noop,
  onMouseLeave: noop,
  groupAngle: 0,
  localScale: 1,
};
export default BlockWrapper;
